// GLOBAL

$(function () {
	'use strict';

	// fix $current.closest(...).size is not a function
    $.fn.size = function () {
        return this.length;
    }

    // IE10 viewport hack for Surface/desktop Windows 8 bug
	// See the Getting Started docs for more information:
	// http://getbootstrap.com/getting-started/#support-ie10-width
	if(navigator.userAgent.match(/IEMobile\/10\.0/))
	{
		var msViewportStyle = document.createElement('style')
		msViewportStyle.appendChild(
			document.createTextNode(
				'@-ms-viewport{width:auto!important}'
			)
		)
		document.querySelector('head').appendChild(msViewportStyle)
	}

	// scroll top
	function onScroll() {
		var $st = $('.scroll-top'),
			v = 'scroll-top-visible',
			y = $(window).scrollTop(),
			b = y + $(window).height();
		if($st.hasClass('scrolling'))
			return;
		if(y > 200) {
			if(!$st.hasClass(v))
				$st.addClass(v);
		} else {
			if($st.hasClass(v))
				$st.removeClass(v);
		}
	}

	var $body = $('body'),
		labelUp = $body.data('up');
	if(!labelUp) labelUp = 'Go Top';
	$body.append('<button class="rounded-top scroll-top">&uarr; <span>' + labelUp + '</span></button>');
	$(document).off('click', 'button.scroll-top').on('click', 'button.scroll-top', function(e){
		var $this = $(this);
		if($this.hasClass('scrolling'))
			return;
		$this.addClass('scrolling');
		$("html, body").animate({ scrollTop: 0 }, {
			duration: 500,
			complete: function(){
				$this.removeClass('scrolling scroll-top-visible');
			}
		});
		e.preventDefault();
	});

	$(window).on('scroll resize', onScroll);

	onScroll();

	$.fn.gInitCommonPlugins = function() {
		// init bootstrap plugins
		$('[rel="tooltip"],.tip', this).tooltip();
		$('[rel="popover"],.pop', this).popover();

		$("select[multiple]", this).css({'padding': '0 !important', 'border': '0 !important'}).selectize({
			plugins: ['remove_button']
		});
		$("select.selectize", this).removeClass('custom-select').selectize({
			plugins: ['remove_button']
		});

		// auto-init popovers & tooltips
		$(this).on("mouseover", '[rel="tooltip"],.tip', function(){
			if(!$(this).data('bs.tooltip')) {
				$(this).tooltip();
				$(this).tooltip("show");
			}
		});
		$(this).on("mouseover", '[rel="popover"],.pop', function(){
			if(!$(this).data('bs.popover')) {
				$(this).popover();
				$(this).popover("show");
			}
		});

		// tags input

		$('.tagsinput', this).each(function(){
			$(this).selectize({
				create: true,
				createFilter: /^[0-9A-Za-zА-Яа-яЁё!\?:\-\+;" ]{2,30}$/,
				createOnBlur: true,
				closeAfterSelect: true,
				openOnFocus: false,
				delimiter: ",",
				maxOptions: 7,
				maxItems: 50,
				dropdownParent: 'body',
				plugins: ['remove_button'],
				load: function(e, callback) {
					App.ajaxRequest('tags/search', {query: e}).done(function(r) {
						callback($.map(r.items, function(item) {
							return { value: item['name'], text: item['name'] };
						}));
					});
				}
			});
		});

		$('.bitrix-groups', this).each(function(){
			var maxItems = 1;
			if($(this).hasClass('multiselect'))
				maxItems = parseInt($(this).data('max_users')) || 10;
			$(this).selectize({
				create: false,
				closeAfterSelect: maxItems < 2,
				openOnFocus: true,
				delimiter: ",",
				maxItems: maxItems,
				maxOptions: 50,
				preload: 'focus',
				dropdownParent: 'body',
				plugins: maxItems > 1 ? ['remove_button'] : [],
				load: function(e, callback) {
					App.ajaxRequest('bitrix/groups', {query: e}).done(function(r) {
						callback($.map(r.items, function(item) {
							var name = item['name'] + ' {' + item['id'] + '}';
							return { value: name, text: name };
						}));
						if(r.error) alert(r.error);
					});
				}
			});
		});

		$('.bitrix-users', this).each(function(){
			var maxItems = 1;
			if($(this).hasClass('multiselect'))
				maxItems = parseInt($(this).data('max_users')) || 10;
			$(this).selectize({
				create: false,
				closeAfterSelect: maxItems < 2,
				openOnFocus: true,
				preload: 'focus',
				delimiter: ",",
				maxOptions: 50,
				maxItems: maxItems,
				dropdownParent: 'body',
				plugins: maxItems > 1 ? ['remove_button'] : [],
				load: function(e, callback) {
					App.ajaxRequest('bitrix/users', {query: e}).done(function(r) {
						callback($.map(r.items, function(item) {
							var name = item['name'] + ' {' + item['id'] + '}';
							return { value: name, text: name };
						}));
						if(r.error) alert(r.error);
					});
				}
			});
		});

		// trigger onscroll actions
		onScroll();
	};

	$(document).ready(function(){
		$('html').removeClass('nojs').addClass('loaded');

		$('#header').headroom();

		$(document).gInitCommonPlugins();

		// init datepickers
		// see https://github.com/nazar-pc/PickMeUp
		$('body').on('focus', 'input[type="date"], input.date', function(){
			if(!this.__pickmeup)
				pickmeup(this, {
					class_name: 'datepicker',
					hide_on_select: true,
					default_date: false,
					format	: 'Y-m-d'
				});
		});

		window.App = new App(window._init || {});
		ko.applyBindings(window.App);
	});
});